export const STAGES = [
  { id: "new", label: "New", color: "bg-neutral-200 text-neutral-800" },
  { id: "contacted", label: "Contacted", color: "bg-sky-100 text-sky-900" },
  { id: "pending", label: "Pending", color: "bg-amber-100 text-amber-900" },
  { id: "deposit_paid", label: "Down payment · awaiting delivery", color: "bg-[#e2b880]/50 text-[#5a3f1c]" },
  { id: "delivered", label: "Paid & delivered", color: "bg-emerald-100 text-emerald-900" },
  { id: "lost", label: "Lost / no answer", color: "bg-rose-100 text-rose-900" },
];

export const CHANNELS = [
  { id: "phone", label: "Call" },
  { id: "sms", label: "Text" },
  { id: "email", label: "Email" },
  { id: "whatsapp", label: "WhatsApp" },
  { id: "in_person", label: "In person" },
  { id: "social", label: "FB / IG" },
];

export const stageOf = (id) => STAGES.find((s) => s.id === id) || STAGES[0];
